import { Component, Input, OnChanges, OnInit, ViewChildren, QueryList, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { SccDog } from 'src/app/scc/shared/services/scc.service';
import { SccMainDicomTags } from 'src/app/shared/models/scc-main-dicom-tags';
import { IDialogContentComponent } from '../../modal-dialog/modal-dialog.service';
import { FormControl } from '@angular/forms';
import { MatExpansionPanel } from '@angular/material/expansion';

@Component({
  selector: 'app-scc-confirm-data',
  templateUrl: './scc-confirm-data.component.html',
  styleUrls: ['./scc-confirm-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SccConfirmDataComponent implements OnInit, OnChanges, OnDestroy, IDialogContentComponent<void, { dicomData: SccMainDicomTags[]; lofData: SccDog }> {
  @Input() input?: { dicomData: SccMainDicomTags[]; lofData: SccDog };
  @ViewChildren(MatExpansionPanel) panels!: QueryList<MatExpansionPanel>;

  confirmDog: FormControl = new FormControl(false);
  expandAll = false;
  private _isDisabled = true;
  isDestroying = false;
  showDetailedTags = true;
  expandedPanels = new Set<number>([0]);

  constructor(private readonly cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.confirmDog.valueChanges.subscribe(value => {
      this._isDisabled = value !== true;
    });
  }

  ngOnDestroy(): void {
    this.isDestroying = true;

    if (this.panels) {
      this.panels.forEach(panel => {
        panel.close();
      });
    }

    setTimeout(() => {
      if (this.input) {
        this.input.dicomData = [];
        this.input = undefined;
      }
    }, 0);

    this.cdr.detach();
  }

  ngOnChanges(): void {
    // Data validation handled by template
  }

  toggleExpandAll(): void {
    this.expandAll = !this.expandAll;

    setTimeout(() => {
      if (this.panels) {
        this.expandedPanels.clear();
        this.panels.forEach((panel, index) => {
          if (this.expandAll) {
            panel.open();
            this.expandedPanels.add(index);
          } else {
            panel.close();
          }
        });
        this.cdr.markForCheck();
      }
    }, 0);
  }

  onPanelToggle(index: number, isExpanded: boolean): void {
    if (isExpanded) {
      this.expandedPanels.add(index);
    } else {
      this.expandedPanels.delete(index);
    }
  }

  isPanelExpanded(index: number): boolean {
    return this.expandedPanels.has(index);
  }

  getResult(): boolean {
    return this.confirmDog.value ?? false;
  }

  isDisabled(): boolean {
    return this._isDisabled;
  }

  public isSimpleValue(value: any): boolean {
    if (typeof value === 'string') {
      return true;
    }

    if (Array.isArray(value) && value.every(item => typeof item === 'string')) {
      return true;
    }

    return false;
  }

  public isArray(value: any): boolean {
    return Array.isArray(value);
  }

  public isObject(value: any): boolean {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
  }

  public objectEntries(obj: any): { key: string; value: any }[] {
    return Object.entries(obj).map(([key, value]) => ({ key, value }));
  }

  trackByFileIndex(index: number, file: any): number {
    return index;
  }

  trackByTagKey(index: number, entry: { key: string; value: any }): string {
    return entry.key;
  }
}
